import { WikiIndexEntry } from '../../../../../../api/help/model'
import { getUserModules } from '../../../../../../helpers/permissionsHelper'
import i18n from '../../../../../../i18n'
import { UserModule } from '../../../../../../model/enums/userModules'
import { wikiIndexItemMapperToVM } from '../../sidePanel.mapper'
import { WikiIndexEntryVM } from '../../sidePanel.model'

export const changelogIndexItemsMapperToVM = (
  indexRoot: WikiIndexEntry,
  section: string
): WikiIndexEntryVM[] => {
  if (!indexRoot || !indexRoot.subPages) return []

  const localeInPath = `/${section.split('/')[1]}`
  const indexForCurrentLocale = indexRoot.subPages.find(subpage => subpage.path === localeInPath)

  let indexForCurrentSection = indexForCurrentLocale?.subPages.find(
    subpage => subpage.path === '/ES/Changelog'
  )?.subPages

  // Default help index (if the wiki hasn't context help for the current page)
  if (!indexForCurrentSection) {
    const defaultHelpPagePath = i18n.t('help:sideHelpRoutes.default')
    indexForCurrentSection = indexForCurrentLocale?.subPages.find(
      subpage => subpage.path === defaultHelpPagePath
    )?.subPages
  }

  const userModules = getUserModules()
  console.log(userModules)

  // Con los userModules puedo filtrar los subpages de indexForCurrentSection que correspondan a esos módulos
  // Por el momento no se habilita este filtro
  return indexForCurrentSection
    ? indexForCurrentSection
        // .filter(index => {
        //   const path = `${index.path.split('/')[3]}`
        //   return userModules.includes(path.toUpperCase() as UserModule)
        // })
        .map(wikiIndexItemMapperToVM)
    : []
}
